"use strict";

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
var _classCallCheck = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var msRest = require("ms-rest-js");
var Mappers = require("../models/mappers");
var WebResource = msRest.WebResource;
/** Class representing a ProviderOperations. */
var ProviderOperations = /*#__PURE__*/function () {
  /**
   * Create a ProviderOperations.
   * @param {ManagedLabsClient} client Reference to the service client.
   */
  function ProviderOperations(client) {
    _classCallCheck(this, ProviderOperations);
    this.client = client;
  }
  /**
   * Result of the request to list REST API operations
   *
   * @param {RequestOptionsBase} [options] Optional Parameters.
   *
   * @returns {Promise} A promise is returned
   *
   * @resolve {HttpOperationResponse} - The deserialized result object.
   *
   * @reject {Error|ServiceError} - The error object.
   */
  return _createClass(ProviderOperations, [{
    key: "listWithHttpOperationResponse",
    value: function listWithHttpOperationResponse(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper, parsedResponse, _resultMapper, deserializationError;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              client = this.client; // Validate
              _context.prev = 1;
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context.next = 4;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context.next = 6;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 6:
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", Promise.reject(_context.t0));
            case 11:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'providers/Microsoft.LabServices/operations';
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'GET';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              httpRequest.body = null;
              // Send Request
              _context.prev = 25;
              _context.next = 28;
              return client.pipeline(httpRequest);
            case 28:
              operationRes = _context.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200)) {
                _context.next = 47;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context.prev = 37;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context.next = 46;
              break;
            case 42:
              _context.prev = 42;
              _context.t1 = _context["catch"](37);
              error.message = "Error \"".concat(_context.t1.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context.abrupt("return", Promise.reject(error));
            case 46:
              return _context.abrupt("return", Promise.reject(error));
            case 47:
              if (!(statusCode === 200)) {
                _context.next = 59;
                break;
              }
              parsedResponse = operationRes.bodyAsJson;
              _context.prev = 49;
              if (parsedResponse !== null && parsedResponse !== undefined) {
                _resultMapper = Mappers.ProviderOperationResult;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper, parsedResponse, 'operationRes.bodyAsJson');
              }
              _context.next = 59;
              break;
            case 53:
              _context.prev = 53;
              _context.t2 = _context["catch"](49);
              deserializationError = new msRest.RestError("Error ".concat(_context.t2, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError.request = msRest.stripRequest(httpRequest);
              deserializationError.response = msRest.stripResponse(response);
              return _context.abrupt("return", Promise.reject(deserializationError));
            case 59:
              _context.next = 64;
              break;
            case 61:
              _context.prev = 61;
              _context.t3 = _context["catch"](25);
              return _context.abrupt("return", Promise.reject(_context.t3));
            case 64:
              return _context.abrupt("return", Promise.resolve(operationRes));
            case 65:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 8], [25, 61], [37, 42], [49, 53]]);
      }));
    }
    /**
     * Result of the request to list REST API operations
     *
     * @param {string} nextPageLink The NextLink from the previous successful call
     * to List operation.
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "listNextWithHttpOperationResponse",
    value: function listNextWithHttpOperationResponse(nextPageLink, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var client, requestUrl, httpRequest, headerName, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper, parsedResponse, _resultMapper2, deserializationError;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              client = this.client; // Validate
              _context2.prev = 1;
              if (!(nextPageLink === null || nextPageLink === undefined || typeof nextPageLink.valueOf() !== 'string')) {
                _context2.next = 4;
                break;
              }
              throw new Error('nextPageLink cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context2.next = 6;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 6:
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              return _context2.abrupt("return", Promise.reject(_context2.t0));
            case 11:
              // Construct URL
              requestUrl = '{nextLink}';
              requestUrl = requestUrl.replace('{nextLink}', nextPageLink);
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'GET';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              httpRequest.body = null;
              // Send Request
              _context2.prev = 22;
              _context2.next = 25;
              return client.pipeline(httpRequest);
            case 25:
              operationRes = _context2.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200)) {
                _context2.next = 44;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context2.prev = 34;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context2.next = 43;
              break;
            case 39:
              _context2.prev = 39;
              _context2.t1 = _context2["catch"](34);
              error.message = "Error \"".concat(_context2.t1.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context2.abrupt("return", Promise.reject(error));
            case 43:
              return _context2.abrupt("return", Promise.reject(error));
            case 44:
              if (!(statusCode === 200)) {
                _context2.next = 56;
                break;
              }
              parsedResponse = operationRes.bodyAsJson;
              _context2.prev = 46;
              if (parsedResponse !== null && parsedResponse !== undefined) {
                _resultMapper2 = Mappers.ProviderOperationResult;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper2, parsedResponse, 'operationRes.bodyAsJson');
              }
              _context2.next = 56;
              break;
            case 50:
              _context2.prev = 50;
              _context2.t2 = _context2["catch"](46);
              deserializationError = new msRest.RestError("Error ".concat(_context2.t2, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError.request = msRest.stripRequest(httpRequest);
              deserializationError.response = msRest.stripResponse(response);
              return _context2.abrupt("return", Promise.reject(deserializationError));
            case 56:
              _context2.next = 61;
              break;
            case 58:
              _context2.prev = 58;
              _context2.t3 = _context2["catch"](22);
              return _context2.abrupt("return", Promise.reject(_context2.t3));
            case 61:
              return _context2.abrupt("return", Promise.resolve(operationRes));
            case 62:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 8], [22, 58], [34, 39], [46, 50]]);
      }));
    }
  }, {
    key: "list",
    value: function list(options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.listWithHttpOperationResponse(options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.listWithHttpOperationResponse(options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "listNext",
    value: function listNext(nextPageLink, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.listNextWithHttpOperationResponse(nextPageLink, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.listNextWithHttpOperationResponse(nextPageLink, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }]);
}();
exports.ProviderOperations = ProviderOperations;